<template>
    <section id="mainContainer">
        <userHeader></userHeader>
        <section class="mid-container">
            <section class="page-banner-section"
                :style="{ 'background-image': `url(${require('@/assets/images/industry-banner.jpg')})` }">
                <div class="container">
                    <h1>{{ constants['INDUSTRY_FOCUS_TEXT'] }}</h1>
                </div>
            </section>

            <section id="tabsFixed" class="fold-menu-section">
                <div class="container">
                    <div class="custom-row">
                        <div class="fold_menu">
                            <ul id="teleporter">
                                <li v-for="(industries, index) in industriesData" :key="index">
                                    <a href="javascript:void(0);" :id="`tabs${index.toString()}`"  @click="scrollToSection(industries.id)">{{ industries.title
                                        }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="fold_menu_receiver">
                            <ul id="receiver"></ul>
                            <div class="menu_arrow">
                                <button id="receiverClick"><img src="static/images/angle-down-white.svg"
                                        alt="" /></button>
                            </div>

                        </div>
                    </div>

                </div>

            </section>

            <section v-for="(industries, index) in industriesData" :id="'section' + industries.id"
            :class="['big-picture-fold', index % 2 === 0 ? 'b-f-left' : 'b-f-right']" :key="industries.id">
                <div class="container clearfix b-f-left">
                    <div class="big-picture">
                        <img :src="getCdnImageAddress(industries.industryImage, `w_575,h_457/`)" alt="" />
                    </div>
                    <div class="picture-content showcontent" id="readMoewaa">
                        <h4>{{ industries.title }}</h4>
                        <div class="fold-txt-box">
                            <h5>
                                <p v-html="industries.shortDescription"></p>
                            </h5>
                            <div class="b_p_txt">
                                <p v-html="getIndustriesDescription(industries)"></p>
                            </div>
                        </div>
                        <div class="page_link" v-if="shouldShowIndustriesReadMore(industries)">
                            <a href="javascript:void(0);" id="readMoewa" @click="toggleIndustriesDescription(industries.id)">
                                {{ isExpandedIndustries(industries.id) ? '<< Read Less' : 'Read More >>' }}</a>
                            <!-- <a href="javascript:void(0);" id="readMoewa">Read More >></a> -->
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <userFooter></userFooter>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import constants from '@/utils/en-US-User.json';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';

interface Industries {
    id: number;
    title: string;
    shortDescription: string;
    description: string;
    industryImage: string;
}

export default defineComponent({
    name: "user-industries",
    components: {
        userHeader,
        userFooter
    },
    data() {
        return {
            constants,
            industriesId: '',
            industriesData: [] as Industries[],
            expandedIndustriesIds: new Set<number>()

        };
    },
    created() {
        this.fetchIndustriesData();
    },
    methods: {
        async fetchIndustriesData() {
            try {
                const response = await axios.get(`${API_BASE_URL}/industry/?status=1`);
                this.industriesData = response.data;
            } catch (err) {
                console.error(err);
            }
        },
        getIndustriesDescription(industries: Industries): string {
            const fullDescription = industries.description;
            if (this.isExpandedIndustries(industries.id) || fullDescription.length <= 280) {
                return fullDescription;
            }
            return `${fullDescription.slice(0, 280)}...`;
        },

        shouldShowIndustriesReadMore(industries: Industries): boolean {
            return industries.description.length > 280;
        },

        toggleIndustriesDescription(industriesId: number) {
            if (this.expandedIndustriesIds.has(industriesId)) {
                this.expandedIndustriesIds.delete(industriesId);
            } else {
                this.expandedIndustriesIds.add(industriesId);
            }
        },

        isExpandedIndustries(industriesId: number): boolean {
            return this.expandedIndustriesIds.has(industriesId);
        },
        scrollToSection(industriesId: number) {
            const section = document.getElementById(`section${industriesId}`);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        }
    }
});
</script>